import React, { useEffect, useState } from "react";
import Modal1 from "./Modal1";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";

// Build the default selection (everything checked) from a control.
const buildDefaultSelection = (control) => {
  const selection = {};
  (control?.cochamps || []).forEach((cochamp) => {
    const fields = {};
    (cochamp.champs || []).forEach((champ) => {
      fields[champ.name] = true;
    });
    selection[cochamp.name] = { checked: true, fields };
  });
  return selection;
};

const ExportControlExcelModal = ({ isOpen, onClose, control, onExport }) => {
  const [selection, setSelection] = useState({});

  useEffect(() => {
    if (isOpen) setSelection(buildDefaultSelection(control));
  }, [isOpen, control]);

  if (!isOpen) return null;

  const toggleCategory = (catName, checked) => {
    setSelection((prev) => {
      const cat = prev[catName] || { fields: {} };
      const fields = {};
      Object.keys(cat.fields).forEach((f) => {
        fields[f] = checked;
      });
      return { ...prev, [catName]: { checked, fields } };
    });
  };

  const toggleField = (catName, fieldName, checked) => {
    setSelection((prev) => {
      const cat = prev[catName] || { fields: {} };
      const fields = { ...cat.fields, [fieldName]: checked };
      const anyChecked = Object.values(fields).some(Boolean);
      return { ...prev, [catName]: { checked: anyChecked, fields } };
    });
  };

  const selectedCount = Object.values(selection).reduce(
    (acc, cat) => acc + Object.values(cat.fields || {}).filter(Boolean).length,
    0
  );

  const handleExport = () => {
    onExport(selection);
    onClose();
  };

  return (
    <Modal1 isOpen={isOpen} onClose={onClose}>
      <div className="bg-white flex flex-col rounded-3xl p-6 w-c700 max-h-c700 cursor-default">
        <div className="flex flex-row justify-between items-center">
          <div className="text-h3 font-bold">Exporter en Excel</div>
          <div
            className="text-h3 text-shadow_50 cursor-pointer border-1 border-shadow_50 rounded-lg px-2 py-0.5 hover:shadow-md"
            onClick={onClose}
          >
            Fermer
          </div>
        </div>
        <div className="text-h4 text-shadow_50 mt-1">
          Sélectionnez les catégories et les champs à inclure.
        </div>

        <div className="flex flex-col gap-4 overflow-y-auto mt-4 pr-2">
          {(control?.cochamps || []).map((cochamp, ci) => {
            const cat = selection[cochamp.name] || { checked: false, fields: {} };
            return (
              <div key={ci} className="flex flex-col gap-2">
                <div className="flex flex-row items-center gap-2 border-b-1 border-shadow_25 pb-1">
                  <CheckBoxGrey
                    checked={!!cat.checked}
                    onChange={(checked) => toggleCategory(cochamp.name, checked)}
                  />
                  <div className="text-h3 font-bold">{cochamp.name}</div>
                </div>
                <div className="flex flex-col gap-1 ml-6">
                  {(cochamp.champs || []).map((champ, fi) => (
                    <div key={fi} className="flex flex-row items-center gap-2">
                      <CheckBoxGrey
                        checked={!!cat.fields?.[champ.name]}
                        onChange={(checked) =>
                          toggleField(cochamp.name, champ.name, checked)
                        }
                      />
                      <div className="text-h3 font-normal text-shadow_50">
                        {champ.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-row justify-end items-center gap-2 mt-4">
          <SecondaryButton onClick={onClose}>Annuler</SecondaryButton>
          <PrimaryButton onClick={handleExport} disabled={selectedCount === 0}>
            Exporter ({selectedCount})
          </PrimaryButton>
        </div>
      </div>
    </Modal1>
  );
};

export default ExportControlExcelModal;
